export const formatPhone = (phone: string, countryCode: string = '+34'): string => {
  const formattedPhone = phone.replace(/[ ()-]/g, '');
  return formattedPhone[0] === '+'
    ? formattedPhone
    : (countryCode + formattedPhone);
};
